import React from "react";
import { Button } from "antd";
import { LeftOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

export default function GoBack({ backPath, queryParams = {} }) {
  const navigate = useNavigate();

  const handleBack = () => {
    console.log("Back button clicked");
    if (backPath) {
      const query = new URLSearchParams();

      Object.entries(queryParams).forEach(([key, value]) => {
        if (value !== undefined && value !== null) {
          query.set(key, String(value));
        }
      });

      // Navigate to the back path with the provided query parameters
      navigate(
        {
          pathname: backPath,
          search: query.toString(),
        },
        { replace: true }
      );
    } else {
      // Default behavior: go back to the previous page in history
      window.history.back();
    }
  };

  return (
    <Button
      type="text"
      className="back-btn"
      onClick={handleBack}
      icon={<LeftOutlined />}
    >
      <span className="responsive-hide">Back</span>
    </Button>
  );
}
